import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=27b54562&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"
import style0 from "./Single.vue?vue&type=style&index=0&id=27b54562&prod&lang=css"
import style1 from "./Single.vue?vue&type=style&index=1&id=27b54562&prod&scoped=true&lang=scss"
import style2 from "@/assets/fusion.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b54562",
  null
  
)

export default component.exports